import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { UploadedImage } from '@/hooks'
import { formatFileSize } from '@/utils/tool-management/excel-file.util'

interface UploadedImagesListProps {
  images: UploadedImage[]
  onRemove: (index: number) => void
  fileSizeUnit: string
}

export function UploadedImagesList({
  images,
  onRemove,
  fileSizeUnit,
}: UploadedImagesListProps) {
  const { t } = useTranslation()
  if (images.length === 0) return null

  return (
    <div className='space-y-2'>
      <p className='text-sm font-medium text-gray-700'>
        {t('toolManagement.imagesUploaded')} ({images.length})
      </p>
      <div className='space-y-2 overflow-y-auto'>
        {images.map((image, index) => (
          <div
            key={index}
            className='flex items-center justify-between p-3 bg-gray-50 rounded-lg'
          >
            <div className='flex items-center space-x-3 flex-1'>
              <img
                src={image.preview}
                alt={image.name}
                className='h-10 w-10 object-cover rounded'
              />
              <div className='flex-1 min-w-0'>
                <p className='text-sm text-gray-700 truncate'>{image.name}</p>
                <p className='text-xs text-gray-500'>
                  {formatFileSize(image.file.size)} {fileSizeUnit}
                </p>
              </div>
            </div>
            <div className='flex items-center space-x-2'>
              {image.progress > 0 && image.progress < 100 && (
                <span className='text-xs text-gray-500'>{image.progress}%</span>
              )}
              <X
                className='h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600'
                onClick={() => onRemove(index)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
